import React from 'react';
import {FieldDefinition} from '../../../shared/fields/types';
import {FieldsTable} from './FieldsTable';
import {createEnrichmentColumns} from './createEnrichmentColumns';

const columns = createEnrichmentColumns<FieldDefinition>();

// Simple enrichment fields table (for CRM and Role Count)
export const SimpleEnrichmentFieldsTable = ({
  fieldDefinitions,
}: {
  fieldDefinitions: FieldDefinition[];
}) => {
  return <FieldsTable fieldDefinitions={fieldDefinitions} columns={columns} />;
};
